import React from 'react';
import { Button, Form, Input, message, Select } from 'antd';
import { ArrowDownIcon } from 'icons';
import { useTranslations } from 'next-intl';

import { useAppDispatch, useAppSelector } from 'store';

import { resetQuestionId, setTestFeedbackModal, useFeedbackErrorType, useSendFeedback } from 'modules/global';

import { Modal } from 'components';

const { TextArea } = Input;

const FeedbackModal = () => {
  const t = useTranslations();
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const questionId = useAppSelector(({ testFeedbackModal }) => testFeedbackModal.questionId);
  const { mutate, isLoading: isSendLoading } = useSendFeedback();
  const { errorType, isLoading } = useFeedbackErrorType(questionId as number);
  const open = useAppSelector(({ testFeedbackModal }) => testFeedbackModal.open);

  const onClose = () => {
    dispatch(setTestFeedbackModal(false));
  };

  const onFinish = (values: { error_id: number; massage: string }) => {
    mutate(
      { ...values, question_id: questionId as number },
      {
        onSuccess: () => {
          onClose();
          message.success(t('Muvaffaqiyatli_bajarildi'));
        }
      }
    );
  };

  const onAfterClose = () => {
    form.resetFields();
    dispatch(resetQuestionId());
  };

  return (
    <Modal
      footer={false}
      open={open}
      centered
      onClose={onClose}
      width="421px"
      closeIcon={false}
      afterClose={onAfterClose}
      styles={{
        content: { padding: '16px', borderRadius: '12px' }
      }}
      title={<span className="text-lg">{t('Testda_biror_xatolik_topdingizmi')}</span>}
    >
      <Form form={form} onFinish={onFinish}>
        <Form.Item
          name="error_id"
          rules={[
            {
              required: true,
              message: ''
            }
          ]}
        >
          <Select
            suffixIcon={<ArrowDownIcon />}
            size="large"
            autoFocus
            placeholder={t('Xatolik_turini_korsating')}
            options={errorType}
            loading={isLoading}
          />
        </Form.Item>
        <Form.Item name="message">
          <TextArea
            className="!border-transparent !bg-gray-100 hover:!border-green-500 focus:!border-green-500"
            rows={4}
            placeholder={t('Xatolikni_matn_shaklida_kiriting')}
            maxLength={200}
          />
        </Form.Item>

        <div className="mt-3 flex items-center gap-2">
          <Button
            onClick={() => onClose()}
            className="w-30 !rounded-lg !border-none !bg-gray-100 !px-3 !py-5 hover:!border-none hover:!text-black"
          >
            {t('ortga')}
          </Button>
          <Button
            loading={isSendLoading}
            htmlType="submit"
            className="!w-full !rounded-lg !border-none !bg-green-500 !px-7 !py-5 !text-white hover:!border-none"
          >
            {t('Yuborish')}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default FeedbackModal;
